import { render } from "./AboutMe.vue?vue&type=template&id=45fef924&scoped=true"
const script = {}

import "./AboutMe.vue?vue&type=style&index=0&id=45fef924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fef924"]])

export default __exports__